import { useTranslation } from 'react-i18next';

const EXCLUSION_TRANSLATION_KEYS = [
  {
    serviceProperty: 'WarrantyExclBra',
    translationKey: 'serviceBracelet',
  },
  {
    serviceProperty: 'WarrantyExclPrf',
    translationKey: 'servicePerformance',
  },
  {
    serviceProperty: 'WarrantyExclWpr',
    translationKey: 'serviceWaterproofness',
  },
];

const Exclusion = ({ services }) => {
  const { t } = useTranslation();
  const service = Array.isArray(services) ? services[0] : undefined;

  const exclusions = EXCLUSION_TRANSLATION_KEYS.filter(
    ({ serviceProperty }) => {
      return service?.[serviceProperty] === 'Y';
    },
  );

  if (exclusions.length === 0) {
    return null;
  }

  return (
    <>
      <div className="heading">{t('serviceExclusion')}</div>

      {exclusions.map(({ serviceProperty, translationKey }) => (
        <div key={serviceProperty} className="description">
          {t(translationKey)}
        </div>
      ))}
    </>
  );
};

export default Exclusion;
